/**
 * @Author: wuyang
 * @Date: 2024/1/23
 * @Description: ""
 */
import { IOpenPayModalProps } from '@/business-component/pay-modal/PayModal'
import { CloseCircleFilled, WechatOutlined, AlipayCircleOutlined, } from '@ant-design/icons'
import { App, QRCode, Modal, Button } from 'antd'
import classNames from 'classnames'
import { useAtomMethod } from '@/helper/hooks/atom-method-hook/useAtomMethod'
import { userinfoService } from '@/common/services/userinfo/userinfoService'
import { useEffect, useState } from 'react'
import {
	canUpdatePackage,
	createOrder,
	getPayListByRefueling,
	getPayListByVipPackage
} from '@/api/vip'
import { useMemoizedFn } from 'ahooks'
import { ISocketMessagePayStatus } from '@/types/socket'

export const PayModalComponent = (
	props: IOpenPayModalProps & { closeModal: () => void }
) => {
	const { closeModal, payType, packageType, refuelingBagId } = props
	// const [messageApi, contextPlaceHolder] = message.useMessage()
	const { message } = App.useApp()
	const [modal, contextHolder] = Modal.useModal()

	const [userInfo] = useAtomMethod(userinfoService.userInfo)

	// 当前选中付费列表的详细信息
	const [activePackage, setActivePackage] = useState<null | {
		packageId: string
		money: number
		qrUrl: string
	}>(null)

	// 付费列表展示
	const [payList, setPayList] = useState<
		Array<{
			id: string
			name: string
			cycle: number
			score: number
			money: number
		}>
	>([])

	// 获取当前套餐详情
	const handleActivePackage = useMemoizedFn((activeId: string) => {
		setActivePackage({
			packageId: activeId,
			money: -1,
			qrUrl: ''
		})
		// canUpdatePackage({
		// 	subId: activeId,
		// 	packageId:
		// 		payType === 1 ? (packageType ?? '') : (userInfo?.packageId ?? ''),
		// 	type: payType
		// }).then(({ money, update, codeUrl }) => {
		// 	// 根据 update 来判断能否升级，后期增加 qrUrl 字符串
		// 	if (update || payType === 0) {
		// 		setActivePackage({
		// 			packageId: activeId,
		// 			money: money,
		// 			qrUrl: codeUrl ?? '-'
		// 		})
		// 	} else {
		// 		message.warning('当前套餐不支持付费购买，请选择其他套餐进行购买')
		// 	}
		// }).catch((err) => {
		// 	if (err?.data?.code === 401) {
		// 		closeModal()
		// 	}
		// 	message.warning(err?.data?.msg)
		// })
		const params = {
			packageId: activeId, // 父套餐id
			productId: activeId, // 子套餐id
			payType: 1, // 支付方式1，微信，2支付宝
			purchaseMode: userInfo?.currentMode || 1, // 购买模式，1，个人，2团队
			teamId: userInfo?.currentMode ? userInfo?.teamId : 0,
			type: 2, // 1，套餐，2加油包
			duration: 365,
		}
		createOrder(params).then((res: any) => {
			if (res.payInfo) {
				setActivePackage({
					packageId: activeId,
					money: res.amount,
					qrUrl: res.payInfo ?? '-'
				})
			} else {
				message.warning('当前套餐不支持付费购买，请选择其他套餐进行购买')
			}

		}).catch((err) => {
			if (err?.data?.code === 401) {
				closeModal()
			}
			message.warning(err?.data?.msg)
		})
	})
	// 添加支付宝支付加载状态
	const [aliPayLoading, setAliPayLoading] = useState(false)
	const AliPay = () => {
		setAliPayLoading(true);
		const params = {
			packageId: activePackage?.packageId, // 父套餐id
			productId: activePackage?.packageId, // 子套餐id
			payType: 2, // 支付方式1，微信，2支付宝
			purchaseMode: userInfo?.currentMode || 1, // 购买模式，1，个人，2团队
			teamId: userInfo?.currentMode ? userInfo?.teamId : 0,
			type: 2, // 1，套餐，2加油包
			duration: 365,
		}
		createOrder(params).then((res: any) => {
			if (res.payInfo) {
				// 处理支付宝支付表单
				const div = document.createElement('div');
				div.innerHTML = res.payInfo;
				document.body.appendChild(div);
				// 自动提交表单
				document.forms[0].submit();
			} else {
				message.warning('当前套餐不支持付费购买，请选择其他套餐进行购买');
			}

		}).catch((err) => {
			if (err?.data?.code === 401) {
				closeModal()
			}
			message.warning(err?.data?.msg)
		}).finally(() => {
			// 无论成功还是失败都取消loading状态
			setAliPayLoading(false);
		})
	}

	// 默认选中第一项
	useEffect(() => {
		if (refuelingBagId) {
			handleActivePackage(refuelingBagId);
		}
	}, [refuelingBagId]);

	// 当没有 refuelingBagId 时，默认选中第一个套餐 - 只在 payList 更新且没有 refuelingBagId 时执行
	useEffect(() => {
		if (!refuelingBagId && payList[0]?.id) {
			handleActivePackage(payList[0].id);
		}
	}, [payList, refuelingBagId]);
	// 动态获取套餐付费列表
	useEffect(() => {
		if (payType) {
			getPayListByVipPackage(`${packageType}`)
				.then((res) => {
					setPayList(
						res?.data?.map((item) => {
							const {
								tariffPackageSubId,
								tariffPackageSubName,
								subMoney,
								cycle,
								score
							} = item
							return {
								id: tariffPackageSubId,
								name: tariffPackageSubName,
								money: subMoney,
								cycle,
								score
							}
						})
					)
				})
				.catch((err) => {
					if (err?.data?.code === 401) {
						closeModal()
					}
					message.warning(err?.data?.msg)
				})
		} else {
			getPayListByRefueling()
				.then((res) => {
					setPayList(
						res.data?.map((item) => {
							const { refuelingBagId, refuelingBagName, money, cycle, score } =
								item
							return {
								id: refuelingBagId,
								name: refuelingBagName,
								money,
								cycle,
								score
							}
						})
					)
				})
				.catch((err) => {
					if (err?.data?.code === 401) {
						closeModal()
					}
					message.warning(err?.data?.msg)
				})
		}
		// eslint-disable-next-line
	}, [payType, packageType])

	const handlePaySocket = useMemoizedFn((data: ISocketMessagePayStatus) => {
		console.log('www--------->支付完成', data)
		if (data.status) {
			message.success(`扫码支付成功`)
			closeModal()
		} else {
			message.warning('扫码支付失败，请重新扫码')
			if (activePackage?.packageId) {
				handleActivePackage(activePackage.packageId)
			}
		}
	})

	useEffect(() => {
		userinfoService.mitt.on('onPayStatus', handlePaySocket)
		return () => {
			userinfoService.mitt.off('onPayStatus', handlePaySocket)
		}
		// eslint-disable-next-line
	}, [])

	const [isModalOpen, setIsModalOpen] = useState(false)

	return (
		<div
			className={
				'relative w-[630px] rounded-lg border border-normal overflow-hidden bg-gradient-to-b from-[#E3F0FF] from-10% to-white'
			}
		>
			{contextHolder} {/* 这里确保 Modal 挂载 */}
			<div
				className={'absolute top-[10px] right-[10px] cursor-pointer'}
				onClick={closeModal}
			>
				<CloseCircleFilled
					className={'text-[22px] text-subDescText hover:text-primary'}
				/>
			</div>
			<div className={'p-[20px]'}>
				<div className={'text-center text-normal text-[24px] font-bold'}>
					{payType === 0 ? '购买算力包' : '升级基础套餐'}
				</div>
				{/* <div className={'flex items-center mt-[10px] text-normal flex-col'}>
					{payType === 0 ? (
						''
					) : (
						<div className={'text-center'}>
							<div>
								您的当前套餐为
								<span className={'ml-[8px] text-primary font-bold'}>
									{userInfo?.packageName}
								</span>
							</div>
							<div>
								剩余积分价值
								<span className={'ml-[8px] text-[#F42929] font-bold'}>
									¥{userInfo?.residueScoreValue}
								</span>
							</div>
						</div>
					)}
				</div> */}
				<div className={'flex justify-between mt-[20px]'}>
					<div
						className={
							'w-[230px] border border-normal rounded-lg bg-white flex items-center flex-col pb-[30px]'
						}
					>
						<div className={'mt-[20px] text-normal'}>购买所需费用</div>
						<div className={'text-[#F42929] text-[30px] font-bold'}>
							¥
							{activePackage && activePackage.money >= 0
								? activePackage.money
								: '--'}
						</div>
						<div className={'mt-[2px]'}>
							<QRCode
								size={160}
								errorLevel="H"
								value={activePackage?.qrUrl || '-'}
								onRefresh={() => {
									if (activePackage?.packageId) {
										handleActivePackage(activePackage.packageId)
									}
								}}
								status={activePackage?.qrUrl ? 'active' : 'loading'}
							/>
						</div>
						<div className='flex items-center gap-2'>
							<div className={'mt-[10px] text-normal flex cursor-pointer py-[4px] px-[8px] rounded-[4px] bg-[#478CDB]/[0.1] border border-[#478CDB]'}>
								<div
									className={
										'w-[22px] h-[22px] rounded-[50%] bg-[#50b674] flex justify-center items-center'
									}
								>
									<WechatOutlined className={'text-white'} />
								</div>
								<div className={'ml-[6px]'}>微信</div>
							</div>
							<div onClick={AliPay} className={'mt-[10px]  py-[4px] px-[8px] border border-[#fff] cursor-pointer text-normal flex hover:border hover:border-[#478CDB] hover:rounded-[4px]'}>
								<div
									className={
										'w-[22px] h-[22px] rounded-[50%] bg-[#1677ff] flex justify-center items-center'
									}
								>
									<AlipayCircleOutlined className={'text-white'} />
								</div>

								<div className={'ml-[6px]'}>
									{aliPayLoading ? '跳转中...' : '支付宝'}
								</div>
								{/* <div className={'ml-[6px]'}>支付宝</div> */}
							</div>
						</div>
						<div className={'mt-[15px] text-subtext text-[14px]'}>
							虚拟商品，不支持退款
						</div>
					</div>
					<div className={'flex-1 py-[5px] ml-[10px] max-h-[358px] overflow-y-scroll scrollbar-container scrollbar-hide'}>
						{payList.map((pay, index) => {
							return (
								<div
									key={pay.id}
									className={classNames(
										'flex border border-normal rounded-lg  justify-between p-[20px] hover:border-[#478CDB] cursor-pointer mb-[10px]',
										pay.id === activePackage?.packageId
											? 'border-[#478CDA] bg-[#478CDB]/[0.1]'
											: 'bg-white',
										index === 0 && 'mt-0'
									)}
									onClick={() => {
										handleActivePackage(pay.id)
									}}
								>
									<div className={'flex-1'}>
										<div className={'text-normal'}>{pay.name}</div>
										<div
											className={'text-subtext mt-[5px]'}
										>{`权益包含${pay.score}积分`}</div>
										<div
											className={'text-subtext mt-[5px]'}
										>{`有效期${pay.cycle}天`}</div>
									</div>
									<div
										className={
											'text-[#F42929] text-[30px] font-bold w-[100px] text-right'
										}
									>
										¥{pay.money}
									</div>
								</div>
							)
						})}
					</div>
				</div>
				<p className='mt-1 text-[#666] text-right mr-[80px]'>支付即视为您已同意 <span onClick={() => setIsModalOpen(true)} className={'text-[#478CDB] cursor-pointer'}>支付协议</span></p>
			</div>
			<Modal
				title="算力积分购买与使用协议"
				open={isModalOpen}
				width={800}
				onCancel={() => setIsModalOpen(false)}
				centered
				footer={[
					<Button type="primary" onClick={() => setIsModalOpen(false)}>
						确认同意
					</Button>
				]}
			>
				<div className='max-h-[70vh] overflow-y-scroll scrollbar-container scrollbar-hide'>
					<p className='text-[#000] text-[16px] mt-[24px]'>一、定义说明</p>
					<p className='text-[#666] text-[14px] mt-[8px]'>1. 算力积分为平台向用户提供的虚拟服务使用凭证，仅用于平台内 AI 功能及算力服务的消耗。</p>
					<p className='text-[#666] text-[14px] mt-[8px]'>2. 算力积分不具备任何现金属性，不可提现、转让、交易或兑换为任何法定货币。</p>

					<p className='text-[#000] text-[16px] mt-[24px]'>二、积分类型说明</p>
					<p className='text-[#666] text-[14px] mt-[8px]'>1. 平台积分包括但不限于：</p>
					<p className='text-[#666] text-[14px] mt-[8px]'>（1）免费赠送积分；</p>
					<p className='text-[#666] text-[14px] mt-[8px]'>（2）用户付费购买的算力积分。</p>
					<p className='text-[#666] text-[14px] mt-[8px]'>2. 不同类型积分在使用范围、有效期及发放规则上可能存在差异，具体以平台实际展示为准。</p>

					<p className='text-[#000] text-[16px] mt-[24px]'>三、免费赠送积分规则</p>
					<p className='text-[#666] text-[14px] mt-[8px]'>1. 免费赠送积分为平台向用户提供的体验型权益，不构成长期或固定承诺。</p>
					<p className='text-[#666] text-[14px] mt-[8px]'>2. 若用户账户中仍存在未使用的免费赠送积分，平台有权暂停当期新的免费积分发放，直至原有免费积分使用完毕。</p>
					<p className='text-[#666] text-[14px] mt-[8px]'>3. 免费赠送积分可能设有使用范围、有效期或发放条件，平台有权根据运营需要进行调整。</p>

					<p className='text-[#000] text-[16px] mt-[24px]'>四、付费积分规则</p>
					<p className='text-[#666] text-[14px] mt-[8px]'>1. 用户在平台购买的算力积分为虚拟服务产品，一经支付成功即视为服务已开始提供。</p>
					<p className='text-[#666] text-[14px] mt-[8px]'>2. 算力积分在实际使用 AI 服务时即时消耗，一经使用不支持退款。</p>
					<p className='text-[#666] text-[14px] mt-[8px]'>3. 未使用的付费积分在有效期内可正常使用，超过有效期将自动失效。</p>

					<p className='text-[#000] text-[16px] mt-[24px]'>五、使用与限制</p>
					<p className='text-[#666] text-[14px] mt-[8px]'>1. 用户应通过平台正规功能使用算力积分，不得通过任何异常或违规方式消耗或获取积分。</p>
					<p className='text-[#666] text-[14px] mt-[8px]'>2. 平台有权对异常使用行为进行限制、暂停或终止服务。</p>

					<p className='text-[#000] text-[16px] mt-[24px]'>六、协议变更与通知</p>
					<p className='text-[#666] text-[14px] mt-[8px]'>1. 平台可根据业务发展及运营需要对本协议及积分规则进行调整。</p>
					<p className='text-[#666] text-[14px] mt-[8px]'>2. 协议变更将通过站内公告、页面提示等方式告知用户，变更后继续使用即视为用户同意更新内容。</p>

					<p className='text-[#000] text-[16px] mt-[24px]'>七、其他</p>
					<p className='text-[#666] text-[14px] mt-[8px]'>1. 本协议未尽事宜，按照平台相关规则及法律法规执行。</p>
					<p className='text-[#666] text-[14px] mt-[8px]'>2. 本协议自用户点击确认同意并完成支付或开始使用相关服务之日起生效。</p>
				</div>
			</Modal>
		</div>
	)
}
